import * as types from './types'
import { VERIFICATION_STEPS_NAME } from '@/entity/verification/constants'

const data = {
	loading: false,
	success: false,
	failed: false,
	data: null
}

const initialState = {
	isLoading: false,
	isSuccess: false,
	error: false,
	qr: null,
	qr_key: null,
	qr_status: {},

	phone: data,
	iin: data,
	send_sms: data,
	step_name: VERIFICATION_STEPS_NAME.step1
}


export const reducer = (state = initialState, actions) => {
	const { type, payload } = actions
	switch (type) {
		case types.TOGGLE_LOADING:
			return { ...state, isLoading: payload }
		case types.TOGGLE_SUCCESS:
			return { ...state, isSuccess: payload }
		case types.TOGGLE_ERROR:
			return { ...state, error: payload }
		case types.SET_QR:
			return { ...state, qr: payload }
		case types.SET_QR_KEY:
			return { ...state, qr_key: payload }
		case types.GET_QR_STATUS:
			return { ...state, qr_status: payload }
		case types.RESET_VERIFICATION:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				error: false,

				iin: data,
				phone: data,
				send_sms: data,
				step_name: initialState.step_name
			}

		case types.SET_SMS_IIN_PHONE:
			return { ...state, iin: {...data, loading: true, data: payload}, phone: {...data, loading: true} }

		case types.SET_SMS_IIN_PHONE_DONE:
			return { ...state, iin: {...state.iin, success: true, loading: false}, phone: {...state.phone, success: true, data: payload, loading: false}, step_name: VERIFICATION_STEPS_NAME.step2 }

		case types.SET_SMS_IIN_PHONE_FAIL:
			return { ...state, iin: {...state.iin, failed: true, success: false, loading: false}, phone: {...state.phone, failed: true, success: false, loading: false}, step_name: VERIFICATION_STEPS_NAME.error }


		case types.SET_SMS_SEND:
			return { ...state, send_sms: {...data, loading: true} }

		case types.SET_SMS_SEND_DONE:
			return { ...state, send_sms: {...data, success: true, data: payload}, step_name: VERIFICATION_STEPS_NAME.step3 }

		case types.SET_SMS_SEND_FAIL:
			return { ...state, send_sms: {...state.send_sms, failed: true, success: false, loading: false}, step_name: VERIFICATION_STEPS_NAME.error }


		case types.STEP_NAME:
			return { ...state, step_name: payload }

		default:
			return state
	}
}
